import type { FunctionComponent, ReactNode } from 'react'

import { FlowPage } from '@monthio/design-system'

import type { WhiteLabelSubdomainInfo } from '../../api/budgetApiClient'

import Header from '../../components/SmartcheckFlowHeader/Header'

export const BudgetHelperPageLayout: FunctionComponent<{
	subdomainInfo: WhiteLabelSubdomainInfo
	consumerInputsStepIndex?: number
	children: ReactNode
}> = ({ subdomainInfo, consumerInputsStepIndex, children }) => {
	const caseConfiguration = subdomainInfo.logo
		? { logo: subdomainInfo.logo, shouldUseBudgetHelper: true }
		: { shouldUseBudgetHelper: true }

	return (
		<>
			<Header
				smartCheckConfiguration={caseConfiguration as any}
				consumerInputsStepIndex={consumerInputsStepIndex}
			/>
			<FlowPage>{children}</FlowPage>
		</>
	)
}
